import { THirePlusUrl } from './types'
import client from '../../client'
import { ResponseSuccess } from '../../types'

export const getHirePlusUrl = async () =>
  await client.get<ResponseSuccess<THirePlusUrl>>(`v1/plus-contracts/session`)
